export class ProjectTaskNotificationSettingsRawDto {
    disableEmailNotifications: boolean;
    notifyMySelf: boolean;
}
